export const financialEffectsLensTexts = {
  SourceDescription: () => <></>,
  SourceTooltipContent: () => <></>,
  LensTitle: () => <>Financial effects</>,
  LensDescription: () => <>Financial effects of sustainability risks and opportunities</>,
  LensTooltipContent: () => <></>,
};
